<template>
  <div class="layout">

    <!-- MOBILE TOPBAR -->
    <div class="mobile-topbar d-flex d-md-none align-items-center px-3">
      <button class="btn btn-sm btn-outline-secondary me-3" data-bs-toggle="offcanvas" data-bs-target="#mobileSidebar" aria-label="Open menu">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"/></svg>
      </button>
      <span class="fw-semibold small">Fitmotivation Admin</span>
    </div>

    <!-- MOBILE OFFCANVAS -->
    <div class="offcanvas offcanvas-start" tabindex="-1" id="mobileSidebar" ref="mobileSidebar">
      <div class="offcanvas-header justify-content-end py-2 border-bottom">
        <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
      </div>
      <div class="offcanvas-body p-0 overflow-auto">
        <PageSidebar />
      </div>
    </div>

    <div class="container-fluid">
      <div class="row g-0 app-row">

        <!-- Desktop Sidebar -->
        <aside class="col-md-2 sidebar p-0 d-none d-md-block">
          <PageSidebar />
        </aside>

        <!-- Main content -->
        <main class="col-12 col-md-10 main-content px-4 py-3">
          <router-view />
        </main>

      </div>
    </div>

  </div>
</template>

<script>
import PageSidebar from "../components/PageSidebar";
import { Offcanvas } from "bootstrap";

export default {
  components: {
    PageSidebar,
  },
  watch: {
    $route() {
      const el = this.$refs.mobileSidebar;
      if (el) {
        const instance = Offcanvas.getInstance(el);
        if (instance) instance.hide();
      }
    },
  },
};
</script>

<style>
/* IMPORTANT: no overflow breaking sticky */
.layout {
  /* leave empty */
}

/* make row full height */
.app-row {
  min-height: 100vh;
  align-items: flex-start;
}

/* ✅ sticky sidebar (now simple) */
.sidebar {
  position: sticky;
  top: 0;

  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;

  border-right: 1px solid #dee2e6;
  background: #f8f9fa;

  /* fixes flexbox sticky issues */
  align-self: flex-start;
}

/* content */
.main-content {
  min-height: 100vh;
  background: #fff;
}

/* mobile topbar */
.mobile-topbar {
  height: 48px;
  background: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  position: sticky;
  top: 0;
  z-index: 1020;
}

/* offcanvas sidebar width */
#mobileSidebar {
  width: 220px;
}
</style>